module.exports = __webpack_public_path__ + "static/media/sentry-icon.a1c90eb4.png";